import React from "react";
import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { CheckCircle, Clock, DollarSign, Users } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1673648072101-0b751cb7281a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/30 to-green-900/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
                Get Your Cash Offer
                <span className="text-blue-400 block">in Minutes</span>
              </h1>
              <p className="text-xl text-gray-200 leading-relaxed">
                Skip the hassle of traditional home selling. Get instant cash offers using advanced AI 
                technology that analyzes market data from millions of data points from our propriertary cash buyer datafeed real time!
              </p>
            </div>

            {/* Key Benefits */}
            <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              <div className="flex flex-col items-center space-y-2 text-center">
                <CheckCircle className="h-8 w-8 text-green-400 flex-shrink-0" />
                <span className="text-gray-200 font-medium">No Repairs Needed</span>
              </div>
              <div className="flex flex-col items-center space-y-2 text-center">
                <Clock className="h-8 w-8 text-blue-400 flex-shrink-0" />
                <span className="text-gray-200 font-medium">Close in 2-4 Weeks</span>
              </div>
              <div className="flex flex-col items-center space-y-2 text-center">
                <DollarSign className="h-8 w-8 text-green-400 flex-shrink-0" />
                <span className="text-gray-200 font-medium">Zero Hidden Fees</span>
              </div>
              <div className="flex flex-col items-center space-y-2 text-center">
                <Users className="h-8 w-8 text-blue-400 flex-shrink-0" />
                <span className="text-gray-200 font-medium">AI-Powered Offers</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all"
                onClick={() => {
                  const offerSection = document.getElementById('offer-submission');
                  if (offerSection) {
                    offerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                Get My Cash Offer Now
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="border-2 border-green-400 text-green-400 hover:bg-green-400 hover:text-black px-8 py-4 text-lg font-semibold rounded-lg transition-all bg-black/20 backdrop-blur-sm"
                onClick={() => {
                  const section = document.getElementById('how-it-works');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                How It Works
              </Button>
            </div>

            {/* Chat Widget Alternative */}
            <div className="text-center">
              <p className="text-sm text-gray-300 italic">
                Don't want to call? Click on our online chat widget instead
              </p>
            </div>

            {/* Trust Indicators */}
            <div className="pt-6 border-t border-gray-600 max-w-md mx-auto">
              <p className="text-sm text-gray-300 mb-3">Trusted by thousands of homeowners across the US</p>
              <div className="flex items-center justify-center space-x-8">
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-400">18</div>
                  <div className="text-sm text-gray-300">Avg Days to Close</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-400">4.9★</div>
                  <div className="text-sm text-gray-300">Customer Rating</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;